module.exports = __webpack_public_path__ + "img/lifecycle-of-sars-cov-2-image.2e1d4d56.png";